module.exports = __webpack_public_path__ + "static/media/005_intel4_1.d2b14034.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/mashery/005_intel4_1.png
// module id = 551
// module chunks = 0